import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import I18n from "^/config/i18n";
import homepageObjIcon from "../../assets/images/homepage_obj.svg";

import {
  defaultPageInitialContent,
  defaultPageProperties,
} from "../_defaultPageEditingConfig";
import {
  metadataInitialContent,
  metadataPropertiesGroup,
  socialCardsPropertiesGroup,
} from "../_metadataEditingConfig";

Scrivito.provideEditingConfig("Homepage", {
  title: I18n.t("Objs.Homepage.title", { ns: "editing" }),
  hideInSelectionDialogs: true,
  thumbnail: homepageObjIcon,
  attributes: localizeAttrList(
    [
      ...defaultPageProperties,
      ...metadataPropertiesGroup.properties,
      "cookieConsentLink",
      "facebookAppId",
      "twitterSite",
      "searchPage",
      "easyLanguagePage",
      "signLanguagePage",
      "favLinks",
      "footerLinks",
      "footerSocialLinks",
      "intranetLoginLink",
      "llmsContent",
    ],
    "Homepage"
  ),
  properties: ["title", "description"],
  propertiesGroups: [
    {
      title: "Site Settings",
      properties: [
        "logo",
        "backgroundColor",
        "cookieBannerText",
        "navigationType",
        "hideInNavigation",
        "showAdditionalNavigationContent",
        "additionalNavigationContentTitle",
      ],
    },
    {
      title: "Functional Pages",
      properties: [
        "searchPage",
        "optionsPage",
        "easyLanguagePage",
        "signLanguagePage",
        "cookieConsentLink",
        "intranetLoginLink",
      ],
    },
    {
      title: "Technical Keys",
      properties: ["facebookAppId", "twitterSite"],
    },
    {
      title: "Disturber",
      properties: [
        "disturberText",
        "disturberLink",
        "disturberValidFrom",
        "disturberValidUntil",
      ],
    },
    {
      title: "StudiAssist Chat",
      properties: [
        "showAiChat",
        "chatUrl",
        "language",
        "iconStyle",
        "showStatusDot",
        "teaserText",
      ],
    },
    {
      title: "Footer",
      properties: ["favLinks", "footerLinks", "footerSocialLinks"],
    },
    socialCardsPropertiesGroup,
    metadataPropertiesGroup,
    {
      title: "AI / llms.txt",
      properties: ["llmsContent"],
    },
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
    showAdditionalNavigationContent: "no",
  },
});
